<template>
  <div class="index-box">
    <div class="title-box">
    </div>
    <div class="login-box">
      <div class="login-content password">
        <div class="login-title" v-if="loginTitle">{{ loginTitle }}</div>
        <div class="title">欢迎登录</div>
        <div class="form-box">
          <div class="line input-box">
            <el-input
              placeholder="请输入手机号"
              v-model="phone"
              clearable
              prefix-icon="el-icon-mobile">
            </el-input>
          </div>
          <div class="line input-box">
            <el-input
              placeholder="请输入密码"
              v-model="password"
              show-password
              prefix-icon="el-icon-lock"
              @keypress.enter.native="submit">
            </el-input>
          </div>
        </div>
        <div class="btn-box">
          <el-button class="submit" :disabled="!canLogin" type="primary" @click="submit">登录</el-button>
        </div>
        <div class="tips">忘记密码可去小程序更改</div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { COOKIE_KEY } from '@/constant';

export default {
  name: 'Index',

  data() {
    return {
      loginTitle: window.settings.loginTitle || '',
      isQr: false,
      phone: '',
      password: '',
    };
  },
  computed: {
    canLogin() {
      return this.phone.trim() && this.password;
    },
  },

  mounted() {
  },

  methods: {
    toCode(str) {
      str = (Math.random() * 10000).toString().slice(0, 4) + str + (Math.random() * 10000).toString().slice(0, 4);
      const key = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const l = key.length;
      const a = key.split('');
      let s = ''; let b; let b1; let b2; let b3;
      for (let i = 0; i < str.length; i += 1) {
        b = str.charCodeAt(i);
        b1 = b % l;
        b = (b - b1) / l;
        b2 = b % l;
        b = (b - b2) / l;
        b3 = b % l;
        s += a[b3] + a[b2] + a[b1];
      }
      return s;
    },
    submit() {
      if (this.canLogin) {
        this.doLogin();
      }
    },
    doLogin() {
      const loading = this.$loading();
      const encryptedPass = this.toCode(this.password);
      this.$axios({
        url: '/sys/login',
        methods: 'post',
        data: {
          phone: this.phone,
          pass: encryptedPass,
        },
      })
        .then((result) => {
          loading.close();
          if (result.data && result.token) {
            Cookies.set(COOKIE_KEY.TOKEN, result.token, { expires: 7 });
            const {
              id, name, photo, role, phone,
            } = result.data;
            const userInfo = {
              id,
              name,
              photo,
              phone,
              role,
            };
            Cookies.set(COOKIE_KEY.USER_INFO, JSON.stringify(userInfo), { expires: 7 });
            this.$message.success('登录成功');
            this.jumpToIndex();
          }
        })
        .catch((e) => {
          loading.close();
          console.error(e);
        });
    },
    jumpToIndex() {
      window.location.href = 'index.html#/overview';
    },
  },
};
</script>

<style lang="scss" scoped>
.index-box {
  height: 100vh;
  min-height: 400px;
  width: 100%;
  display: flex;
  position: relative;
}
.title-box {
  height: 100%;
  background: url('~@/assets/img/login-bg.webp') center;
  background-size: cover;
  color: #fff;
  font-size: 44px;
  padding: 30px 30px 35vh;
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  letter-spacing: 10px;
}
.login-box {
  position: relative;
  z-index: 2;
  flex: 1;
  min-width: 480px;
  background-color: $white;
  padding: 80px 100px;
  border-radius: 4px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-content {
  padding-bottom: 10vh;
  width: 100%;
  .login-title {
    font-size: 40px;
    color: #000;
    margin-bottom: 40px;
    text-align: left;
    font-weight: 500;
  }
  .title {
    font-weight: bold;
    font-size: 30px;
    margin-bottom: 50px;
    text-align: left;
  }
  .input-box {
    & + .input-box {
      margin-top: 20px;
    }
  }
  .btn-box {
    margin-top: 50px;
    .submit {
      width: 100%;
    }
  }
  .tips {
    margin-top: 30px;
    font-size: 14px;
    color: $text-secondary;
  }
}
</style>
